/**
 * Keeps one AMP/AISPROGRAM (SKU) line item in the cart in sync with the total
 * quantity of "AIS Programming" tagged products in the cart.
 *
 * The source of truth for "how many are required" and "how many are
 * currently in the cart" is computed server-side in Liquid (see
 * snippets/cart-items.liquid) and exposed via a hidden marker element,
 * because product tags aren't available in the Ajax Cart API's JSON. This
 * script just watches that marker and reconciles the cart via
 * /cart/update.js whenever it changes.
 */
(function () {
  if (window.__aisProgrammingSyncInit) return;
  window.__aisProgrammingSyncInit = true;

  var isSyncing = false;
  var pendingRecheck = false;

  function getMarker() {
    return document.getElementById('ais-programming-sync-data');
  }

  async function check() {
    var marker = getMarker();
    if (!marker) return;

    var variantId = marker.dataset.serviceVariantId;
    var required = parseInt(marker.dataset.requiredQty || '0', 10);
    var current = parseInt(marker.dataset.currentQty || '0', 10);

    if (!variantId || variantId === '0' || required === current) return;

    if (isSyncing) {
      pendingRecheck = true;
      return;
    }

    isSyncing = true;

    try {
      var updates = {};
      updates[variantId] = required;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      });

      var cartItemsEl = document.getElementById('cart-items');
      if (cartItemsEl && typeof cartItemsEl.refresh === 'function') {
        await cartItemsEl.refresh();
      }
    } catch (err) {
      console.error('AIS programming sync failed:', err); // eslint-disable-line
    } finally {
      isSyncing = false;
      if (pendingRecheck) {
        pendingRecheck = false;
        check();
      }
    }
  }

  var observer = new MutationObserver(function () {
    check();
  });

  function start() {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
